import { useState, } from "react";
import Icons from "../myIcon/Icons";
import { Link } from "react-router-dom";
import React from "react";

export default function MobileMenu({ isOpen, setIsOpen }) {
  const [isInner1, setIsInner1] = useState(false);
  const [isInner2, setIsInner2] = useState(false);
  const [isInner3, setIsInner3] = useState(false);
  const [isInner4, setIsInner4] = useState(false);
  const [isInner5, setIsInner5] = useState(false);
  const [isInner6, setIsInner6] = useState(false);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
        <div className="mobilemenu-header">
          <Link to={"/"} onClick={handleLinkClick}><img src="/logo.webp" alt="Logo" /></Link>
          <button className="menu-close-btn" onClick={() => { handleLinkClick(); setIsInner3(false); }} aria-label="Close menu">✕</button>
        </div>

        <ul className="mobile-mainmenu">
          <li><Link to={"/"} onClick={handleLinkClick}>Home</Link></li>

          <li><Link onClick={() => setIsInner1(true)}>company <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner2(true)}>Tecnologies <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner3(true)}>Industries <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner4(true)}>Use By Case <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner5(true)}>Services <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner6(true)}>Insights <Icons name="arrowRight" /></Link></li>

          <li><Link to={"/contact"} onClick={handleLinkClick}>Contact Us</Link></li>
        </ul>

        <div className={isInner1 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner1(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>

            <div className="mobileinner-link">
              <Link to={"/about-us"} onClick={() => { handleLinkClick(); setIsInner1(false); }}>About</Link>
              <Link to={"/location"} onClick={() => { handleLinkClick(); setIsInner1(false); }}>Our locations</Link>
              <Link to={"/team"} onClick={() => { handleLinkClick(); setIsInner1(false); }}>Our Team</Link>
              <Link to={"/sustainability"} onClick={() => { handleLinkClick(); setIsInner1(false); }}>sustainability</Link>
            </div>
          </div>
        </div>

        <div className={isInner2 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner2(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>

            <div className="mobileinner-link">
              <Link to={"/artificial-intelligence"} onClick={() => { handleLinkClick(); setIsInner2(false); }}>Artificial Intelligence</Link>
              <Link to={"/cloud-computing"} onClick={() => { handleLinkClick(); setIsInner2(false); }}>Cloud Computing</Link>
              <Link to={"/data-analytics"} onClick={() => { handleLinkClick(); setIsInner2(false); }}>data analytics</Link>
              <Link to={"/data-integration-visibility"} onClick={() => { handleLinkClick(); setIsInner2(false); }}>Data integration & visibility</Link>
              <Link to={"/infrastructure"} onClick={() => { handleLinkClick(); setIsInner2(false); }}>infrastructure</Link>
              <Link to={"/iot-enabled"} onClick={() => { handleLinkClick(); setIsInner2(false); }}>IOT enabled</Link>
            </div>
          </div>
        </div>

        <div className={isInner3 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner3(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>

            <div className="mobileinner-link">
              <Link to={"/cpg-retail-records-management"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>CPG & Retail</Link>
              <Link to={"/education-training"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>Education Training</Link>
              <Link to={"/financial-institutions"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>Finance</Link>
              <Link to={"/government-records-management-services"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>government</Link>
              <Link to={"/healthcare"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>Healthcare</Link>
              <Link to={"/insurance-document-management-services"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>insurance</Link>
              <Link to={"/media-entertainment-records-management"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>Media & Entertainment</Link>
              <Link to={"/other-industries-we-serve"} onClick={() => { handleLinkClick(); setIsInner3(false); }}>other industries</Link>
            </div>
          </div>
        </div>

        <div className={isInner4 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner4(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>

            <div className="mobileinner-link">
              <Link to={"/finance-document-management-services"} onClick={() => { handleLinkClick(); setIsInner4(false); }}>Finance & Accounting</Link>
              <Link to={"/hr-document-management-services"} onClick={() => { handleLinkClick(); setIsInner4(false); }}>Human Resources</Link>
              <Link to={"/enterprise-document-management-solutions"} onClick={() => { handleLinkClick(); setIsInner4(false); }}>Large enterprise</Link>
              <Link to={"/mobile-workforce-document-solutions"} onClick={() => { handleLinkClick(); setIsInner4(false); }}>mobile workforce</Link>
              <Link to={"/sales-document-management-solutions"} onClick={() => { handleLinkClick(); setIsInner4(false); }}>sales</Link>
              <Link to={"/small-business-solution"} onClick={() => { handleLinkClick(); setIsInner4(false); }}>Small Business Solution</Link>
            </div>
          </div>
        </div>

        <div className={isInner5 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner5(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>

            <div className="mobileinner-link">

              <Link to={"/ai-document-data-extraction"} onClick={() => { handleLinkClick(); setIsInner5(false); }}>AI extraction</Link>
              <Link to={"/data-privacy-governance-compliance-platform"} onClick={() => { handleLinkClick(); setIsInner5(false); }}>data platform</Link>
              <Link to={"/document-digitization"} onClick={() => { handleLinkClick(); setIsInner5(false); }}>Document digitization</Link>
              <Link to={"/physical-records-management-services"} onClick={() => { handleLinkClick(); setIsInner5(false); }}>physical records</Link>
            </div>
          </div>
        </div>

        <div className={isInner6 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner6(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>

            <div className="mobileinner-link">
              <Link to={"/blog"} onClick={() => { handleLinkClick(); setIsInner6(false); }}>Blogs</Link>
              {/* <Link to={"/case-study"} onClick={() => { handleLinkClick(); setIsInner6(false); }}>case studies</Link>
              <Link to={"/press-release"} onClick={() => { handleLinkClick(); setIsInner6(false); }}>Press Releases</Link> */}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
